import React from 'react';
import { components } from 'react-select';

/**
 * Defines a MenuList component to be used with React-Select. This component adds
 * a search box atop the menu dropdown. The base MenuList component is left unaltered
 * otherwise.
 */
const SearchMenuList = (all) => {
  const { selectProps, ...props } = all;
  const {
    onInputChange, inputValue, onMenuInputFocus, setInputValue, setIsFocused,
  } = selectProps;
  const { children } = props;

  return (
    <div
      className="has-search"
      onClick={(e) => {
        setIsFocused(true);
        e.stopPropagation();
      }}
      // Add keydown listener to satisfy jsx-ally/click-events-have-key-events
      // ESLint error
      onKeyDown={(e) => {
        setIsFocused(true);
        e.stopPropagation();
      }}
    >
      <form className="search-form">
        <input
          className="filter-input"
          autoCorrect="off"
          autoComplete="off"
          spellCheck="false"
          type="text"
          value={inputValue}
          onChange={(e) => onInputChange(e.currentTarget.value, {
            action: 'input-change',
          })}
          onMouseDown={(e) => {
            e.stopPropagation();
            // @ts-ignore
            e.target.focus();
          }}
          onTouchEnd={(e) => {
            e.stopPropagation();
            // @ts-ignore
            e.target.focus();
          }}
          onFocus={onMenuInputFocus}
          placeholder="Search..."
        />
        <button
          className="filter-reset"
          type="reset"
          onClick={(e) => {
            setInputValue('');
            e.stopPropagation();
            // @ts-ignore
            e.target.previousSibling.focus();
          }}
        >
          &times;
        </button>
      </form>

      <components.MenuList
        {...props}
        selectProps={selectProps}
      >
        {children}
      </components.MenuList>
    </div>
  );
};

export default SearchMenuList;
